import React from 'react';
import Outer from '../../Templates/Outer';
import Login from '../AdminUsers/Login';

function LoginDedicated() {
  return (
    <Outer>
      <Login />
    </Outer>
  );
}

export default LoginDedicated;
